import React, { useState } from 'react'
import 'react-image-gallery/styles/css/image-gallery.css'
import Hotkeys from 'react-hot-keys'
import ImageGallery from 'react-image-gallery'
import './styles.css'
import Lightbox from 'react-image-lightbox'
import { rotate } from '../../utils/images'

const NEXT_KEY = 'control+i'
const ZOOM_IN_KEY = '='
const ZOOM_OUT_KEY = '-'

const WizardGallery = ({ images }) => {
  let onNext
  const [imageSrc, setImageSrc] = useState('')

  const onKeyUp = (keyName, e, handle) => {
    if (keyName === NEXT_KEY && onNext) {
      onNext()
    }

    if (keyName === ZOOM_IN_KEY) {
      onMagnifierOn()
    }
    if (keyName === ZOOM_OUT_KEY) {
      onCloseLightbox()
    }
  }

  const renderLeftNav = (onClick, disabled) => (
    <span title='Previous' className={'left-icon-wrapper'} onClick={onClick}>
      <i className='fa fa-chevron-left fa-3x' />
      <span>Previous</span>
    </span>
  )

  const renderRightNav = (onClick, disabled) => {
    onNext = onClick
    return (
      <span title='Next Image ^+I' className={'right-icon-wrapper'} onClick={onClick}>
        <i className='fa fa-chevron-right fa-3x' />
        <span>Next Image ^+I</span>
      </span>
    )
  }

  const onRotate = () => {
    rotate()
  }

  const onCloseLightbox = () => {
    setImageSrc('')
    closeLightbox()
  }

  const onOpenLightbox = ({ target }) => openLightbox(target.getAttribute('src'))

  const onMagnifierOn = () => {
    const image = document.querySelectorAll('.image-gallery-slide.center img')[0]
    if (image) {
      const img = image.getAttribute('src')
      openLightbox(img)
    }
  }

  const openLightbox = (img) => setImageSrc(img)

  const closeLightbox = () => setImageSrc(null)

  return (
    <Hotkeys keyName={[NEXT_KEY, ZOOM_IN_KEY, ZOOM_OUT_KEY].join(',')} onKeyUp={onKeyUp}>
      <div style={{ position: 'relative' }}>
        <>
          <span title='Rotate ^+R' className={'rotate-icon-wrapper'} onClick={onRotate}>
            <i className='fa fa-rotate-left fa-3x rotate-icon' />
            <span>Rotate ^+R</span>
          </span>
          <span title='Magnifier Tool' className={'magnifier-icon-wrapper'} onClick={onMagnifierOn}>
            <i className='fa fa-search-plus fa-3x rotate-icon' />
            <span>Zoom In =</span>
          </span>
          <div className='wizard-gallery'>
            <ImageGallery
              items={images}
              showThumbnails={false}
              showFullscreenButton={false}
              showPlayButton={false}
              renderLeftNav={renderLeftNav}
              renderRightNav={renderRightNav}
              onClick={onOpenLightbox}
              // disableArrowKeys
            />
          </div>
        </>
      </div>
      {imageSrc && <Lightbox mainSrc={imageSrc} onCloseRequest={onCloseLightbox} />}
    </Hotkeys>
  )
}

export default WizardGallery
